import {BrainImage} from './print-card.models';

export class LoadBrainImages {
  static type = '[PrintCard] Load Brain Images';
}

export class LoadBrainImagesSuccess {
  static type = '[PrintCard] Load Brain Images Success';
  constructor(public brainImages: BrainImage[]) {}
}

export class SetColor {
  static type = '[PrintCard] Set Color';
  constructor(public color: string) {}
}
